import _ from "lodash";
import { API } from "aws-amplify";
import { FETCH_SETTINGS, PUSH_NOTIFICATION } from "./types";
import {getEnvironmentName} from "../../utils"
const environment = getEnvironmentName()
const config = require("../../app_configuration").CONFIGURATION[environment];

const apiRequestFixedParams = {
  Version: config.RESPONSUM_API_VERSION,
  Api: config.RESPONSUM_API,
  AccountType: config.RESPONSUM_API_RESOURCE_TYPE.PRIVATE
};

export const fetchChatbotSettings = () => async (dispatch, getState) => {
  const state = getState();
  let data = {
    body: {
      ApiCall: "GetPublicBotSettings",
      Skill: _.omit(state.skill, ["buildInfo"]),
      ...apiRequestFixedParams
    },
    headers: {
      Authorization: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken
    }
  };
 

  await API.post(config.AWS_API_NAME, "skills", data)
    .then(response => {
      dispatch({
        type: FETCH_SETTINGS,
        payload: response
      });
    })
    .catch(error => {
      console.error("error", error);
      dispatch({
        type: PUSH_NOTIFICATION,
        payload: {
          message: "Error while fetching chatbot settings!",
          type: "error"
        }
      });
    });
};

export const updateChatbotSettings = params => async (dispatch, getState) => {
  const state = getState();

  let data = {
    body: {
      ApiCall: "UpdatePublicBotSettings",
      Skill: _.omit(state.skill, ["buildInfo"]),
      ...apiRequestFixedParams,
      ...params
    },
    headers: {
      Authorization: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken
    }
  };

  await API.post(config.AWS_API_NAME, "skills", data)
    .then(response => {
      if(!params.first){
        dispatch({
          type: PUSH_NOTIFICATION,
          payload: {
            message: "Successfully updated chatbot settings.",
            type: "success"
          }
      });}
    })
    .catch(error => {
      console.error("error", error);
      dispatch({
        type: PUSH_NOTIFICATION,
        payload: {
          message: "Error updating chatbot settings!",
          type: "error"
        }
      });
    });
};

export const updateChatbotColorSettings = params => async (dispatch, getState) => {
  const state = getState();
  let data = {
    body: {
      ApiCall: "UpdatePublicBotColorSettings",
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      Skill: _.omit(state.skill, ["buildInfo"]),
      ...apiRequestFixedParams,
      ...params
    }
  };

  await API.post(config.AWS_API_NAME, "skills", data)
    .then(response => {
      dispatch({
        type: PUSH_NOTIFICATION,
        payload: {
          message: "Successfully updated chatbot color settings.",
          type: "success"
        }
      });
    })
    .catch(error => {
      console.error("error", error);
      dispatch({
        type: PUSH_NOTIFICATION,
        payload: {
          message: "Error updating chatbot color settings!",
          type: "error"
        }
      });
    });
};

export const updateChatbotCuesSettings = params => async (dispatch, getState) => {
  const state = getState();
  let data = {
    body: {
      ApiCall: "UpdatePublicBotCuesSettings",
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      Skill: _.omit(state.skill, ["buildInfo"]),
      ...apiRequestFixedParams,
      ...params
    }
  };

  await API.post(config.AWS_API_NAME, "skills", data)
    .then(response => {
      dispatch({
        type: PUSH_NOTIFICATION,
        payload: {
          message: "Successfully updated chatbot cues settings.",
          type: "success"
        }
      });
    })
    .catch(error => {
      console.error("error", error);
      dispatch({
        type: PUSH_NOTIFICATION,
        payload: {
          message: "Error updating chatbot cues settings!",
          type: "error"
        }
      });
    });
};
